export enum EventBusEvent {
  DimensionsUpdateStarted = 'DIMENSIONS UPDATE STARTED',
  DimensionsUpdateFinished = 'DIMENSIONS UPDATE FINISHED',

  ControlPressed = 'CONTROL PRESSED',
  ControlReleased = 'CONTROL RELEASED',

  EscapePressed = 'ESCAPE PRESSED',

  IsBlurred = 'IS BLURRED',
  IsFocused = 'IS FOCUSED',

  ToggleNavSidebar = 'TOGGLE NAV SIDEBAR',

  MainContentScrolledToTop = 'MAIN CONTENT SCROLLED TO TOP',
  MainContentScrolledToBottom = 'MAIN CONTENT SCROLLED TO BOTTOM',
}
